import { AxiosResponse } from "axios";
import ApiNames from "../Constants/ApiNames";
import { Config } from "../Constants/Config";
import { bearerAuthConfig, get, post } from "./NetworkService";
import {
  CheckAlreadySubscribedApiResponse,
  CheckOperatorApiResponse,
  FetchLoginApiResponse,
  FetchSubscribeApiResponse,
  GenerateTokenApiResponse,
  SendOtpApiResponse,
  UnsubscribeApiResponse,
  VerifyOtpApiResponse,
} from "../Types/Auth";

export const generateToken = (): Promise<
  AxiosResponse<GenerateTokenApiResponse>
> =>
  post(
    ApiNames.generateToken,
    { username: Config.TOKEN_USERNAME, password: Config.TOKEN_PASSWORD },
    bearerAuthConfig(null)
  );

export const checkAlreadySubscribed = (
  msisdn: string
): Promise<AxiosResponse<CheckAlreadySubscribedApiResponse>> =>
  get(`${ApiNames.CheckAlreadySubscribed}?msisdn=${msisdn}`);

export const checkOperator = (
  msisdn: string
): Promise<AxiosResponse<CheckOperatorApiResponse>> =>
  get(`${ApiNames.checkOperator}?msisdn=${msisdn}`);

export const sendOtp = (
  msisdn: string,
  token: string | null
): Promise<AxiosResponse<SendOtpApiResponse>> =>
  get(`${ApiNames.sendOtp}?msisdn=${msisdn}`, bearerAuthConfig(token));

export const verifyOtp = (
  msisdn: string,
  otp: string,
  os: string,
  uuid: string,
  token: string | null
): Promise<AxiosResponse<VerifyOtpApiResponse>> =>
  get(
    `${ApiNames.verifyOTP}?msisdn=${msisdn}&otp=${otp}&os=${os}&uuid=${uuid}`,
    bearerAuthConfig(token)
  );

export const fetchLogin = (
  msisdn: string,
  token: string | null
): Promise<AxiosResponse<FetchLoginApiResponse>> =>
  get(`${ApiNames.fetchLoginApi}?msisdn=${msisdn}`, bearerAuthConfig(token));

export const fetchSubscribe = (
  msisdn: string,
  token: string | null
): Promise<AxiosResponse<FetchSubscribeApiResponse>> =>
  get(
    `${ApiNames.fetchSubscribeApi}?msisdn=${msisdn}`,
    bearerAuthConfig(token)
  );

export const unsubscribe = (
  msisdn: string | null
): Promise<AxiosResponse<UnsubscribeApiResponse>> =>
  get(`${ApiNames.unsubscribe}?msisdn=${msisdn}`);
